import React, { PropsWithChildren, useEffect } from 'react'

import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'

import Loading from '@components/UI/Loading'
import { NoticeEmpty } from '@components/UI/Notice'
import { selectBillingType } from '@store/router'

export interface IPurchaseWrapperProps {
  hasPurchases: boolean
  enableFetch: boolean
  fetchList: VoidFunction
  isLoading: boolean
}

const PurchaseWrapper: React.FC<PropsWithChildren<IPurchaseWrapperProps>> = ({
  children,
  hasPurchases,
  enableFetch,
  fetchList,
  isLoading,
}) => {
  const location = useLocation()
  const billingType = selectBillingType(location)

  useEffect(() => {
    if (enableFetch) {
      fetchList()
    }
  }, [])

  if (!hasPurchases && !isLoading) {
    return (
      <NoticeEmpty
        alt="purchases"
        title={<FormattedMessage id="billing.empty.title" />}
        subtitle={<FormattedMessage id={`billing.empty.${billingType}.subtitle`} />}
      />
    )
  }

  if (isLoading) {
    return <Loading />
  }

  return <React.Fragment>{children}</React.Fragment>
}

export { PurchaseWrapper }
export default PurchaseWrapper
